module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-flyer.991001e7.jpg";